import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "main-section" }
const _hoisted_2 = { class: "content-section" }
const _hoisted_3 = { class: "text-block full-width" }
const _hoisted_4 = { class: "game-description list game-list" }
const _hoisted_5 = { class: "content-section reverse-layout" }
const _hoisted_6 = { class: "game-description" }
const _hoisted_7 = { class: "game-description" }
const _hoisted_8 = { class: "game-description" }
const _hoisted_9 = { class: "content-section reverse-layout" }
const _hoisted_10 = { class: "game-description" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Accent = _resolveComponent("Accent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[17] || (_cache[17] = _createElementVNode("h1", { class: "title" }, "Things I learned", -1)),
        _createElementVNode("ul", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.projectData.learn, (task, index) => {
            return (_openBlock(), _createElementBlock("li", {
              class: "game-description game-list",
              key: index
            }, _toDisplayString(task), 1))
          }), 128))
        ]),
        _cache[18] || (_cache[18] = _createElementVNode("h1", { class: "title" }, "My contributions", -1)),
        _cache[19] || (_cache[19] = _createElementVNode("p", { class: "game-description" }, " For this project, I was a gameplay, engine/tools and audio programmer. I was in a team with 2 graphics programmers, 1 other engine programmer and 2 gameplay programmers and we made this engine from scratch. ", -1)),
        _createElementVNode("ul", _hoisted_4, [
          _createElementVNode("li", null, [
            _cache[1] || (_cache[1] = _createTextVNode("Designed and implemented back-end systems for the audio system on PlayStation 4 and Windows platforms, including a ")),
            _createVNode(_component_Accent, null, {
              default: _withCtx(() => _cache[0] || (_cache[0] = [
                _createTextVNode("custom song loader")
              ])),
              _: 1
            }),
            _cache[2] || (_cache[2] = _createTextVNode(" capable of extracting BPM information from files created in industry-standard DAWs."))
          ]),
          _createElementVNode("li", null, [
            _cache[4] || (_cache[4] = _createTextVNode("Created the ")),
            _createVNode(_component_Accent, null, {
              default: _withCtx(() => _cache[3] || (_cache[3] = [
                _createTextVNode("Beatmatching system")
              ])),
              _: 1
            }),
            _cache[5] || (_cache[5] = _createTextVNode(" for both platforms, leveraging byte position data from the audio system to accurately determine when the next beat should occur."))
          ]),
          _createElementVNode("li", null, [
            _cache[7] || (_cache[7] = _createTextVNode("Managed resource handling for Windows and PlayStation 4, developing ")),
            _createVNode(_component_Accent, null, {
              default: _withCtx(() => _cache[6] || (_cache[6] = [
                _createTextVNode("tools to streamline resource management")
              ])),
              _: 1
            }),
            _cache[8] || (_cache[8] = _createTextVNode(" and enabling rapid resource transfers to the PlayStation 4 for quick testing."))
          ]),
          _createElementVNode("li", null, [
            _cache[12] || (_cache[12] = _createTextVNode("Developed multiple tools within the engine, including a ")),
            _createVNode(_component_Accent, null, {
              default: _withCtx(() => _cache[9] || (_cache[9] = [
                _createTextVNode("UI tool")
              ])),
              _: 1
            }),
            _cache[13] || (_cache[13] = _createTextVNode(", ")),
            _createVNode(_component_Accent, null, {
              default: _withCtx(() => _cache[10] || (_cache[10] = [
                _createTextVNode("audio debugging tools")
              ])),
              _: 1
            }),
            _cache[14] || (_cache[14] = _createTextVNode(", and a ")),
            _createVNode(_component_Accent, null, {
              default: _withCtx(() => _cache[11] || (_cache[11] = [
                _createTextVNode("level editor/creator")
              ])),
              _: 1
            }),
            _cache[15] || (_cache[15] = _createTextVNode("."))
          ]),
          _cache[16] || (_cache[16] = _createElementVNode("li", null, "Built a framework that empowered tool and gameplay programmers to create custom tools for various systems within the engine.", -1))
        ])
      ])
    ]),
    _createElementVNode("section", _hoisted_5, [
      _cache[29] || (_cache[29] = _createElementVNode("h1", { class: "title" }, "Beatmatching", -1)),
      _createElementVNode("p", _hoisted_6, [
        _cache[21] || (_cache[21] = _createTextVNode("My most significant contribution to this project has been the ")),
        _createVNode(_component_Accent, null, {
          default: _withCtx(() => _cache[20] || (_cache[20] = [
            _createTextVNode("beatmatching system")
          ])),
          _: 1
        }),
        _cache[22] || (_cache[22] = _createTextVNode(" and all the features it provided."))
      ]),
      _createElementVNode("p", _hoisted_7, [
        _cache[24] || (_cache[24] = _createTextVNode("Wav files were loaded via a ")),
        _createVNode(_component_Accent, null, {
          default: _withCtx(() => _cache[23] || (_cache[23] = [
            _createTextVNode("custom library that I created")
          ])),
          _: 1
        }),
        _cache[25] || (_cache[25] = _createTextVNode(". This library is capable of extracting bpm info from the track."))
      ]),
      _cache[30] || (_cache[30] = _createElementVNode("p", { class: "game-description" }, "I wanted the rhythm-based features to be flexible for any mechanic. I decided to use a simple metronome system that notifies the objects that have the beatmatching component added onto them that a new beat has been hit.", -1)),
      _createElementVNode("p", _hoisted_8, [
        _cache[27] || (_cache[27] = _createTextVNode("As mentioned earlier, the beatmatching system has a ")),
        _createVNode(_component_Accent, null, {
          default: _withCtx(() => _cache[26] || (_cache[26] = [
            _createTextVNode("metronome-type system")
          ])),
          _: 1
        }),
        _cache[28] || (_cache[28] = _createTextVNode(" that counts every beat based on the bpm of the current soundtrack."))
      ]),
      _cache[31] || (_cache[31] = _createElementVNode("p", { class: "game-description" }, "It retrieves the position in ms of the current soundtrack and checks if the last known position in the beatmatching system is less than that. If it happens to be less than the current position, a new beat has been hit.", -1)),
      _cache[32] || (_cache[32] = _createElementVNode("video", {
        class: "media-video full-width",
        controls: "",
        "aria-hidden": "true",
        poster: "/gudenuffengine/src/img/thumb_gudenuffengine_beatmatching.jpg"
      }, [
        _createElementVNode("source", {
          src: "/gudenuffengine/src/mp4/gudenuffengine_beatmatching.webm",
          type: "video/webm"
        }),
        _createElementVNode("source", {
          src: "/gudenuffengine/src/mp4/gudenuffengine_beatmatching_c.mp4",
          type: "video/mp4"
        }),
        _createTextVNode(" Your browser does not support the video tag. ")
      ], -1))
    ]),
    _createElementVNode("section", _hoisted_9, [
      _cache[36] || (_cache[36] = _createStaticVNode("<h1 class=\"title\" data-v-603d8ced>Resource Management</h1><video class=\"media-video right\" controls aria-hidden=\"true\" poster=\"/gudenuffengine/src/img/thumb_gudenuffengine_resourcemanagement.jpg\" data-v-603d8ced><source src=\"/gudenuffengine/src/mp4/gudenuffengine_resourcemanagement.webm\" type=\"video/webm\" data-v-603d8ced><source src=\"/gudenuffengine/src/mp4/gudenuffengine_resourcemanagement_c.mp4\" type=\"video/mp4\" data-v-603d8ced> Your browser does not support the video tag. </video><p class=\"game-description\" data-v-603d8ced>All the resources in the game, sprites, fonts, sounds are all saved in the resource manager.</p>", 3)),
      _createElementVNode("p", _hoisted_10, [
        _cache[34] || (_cache[34] = _createTextVNode("Resources are saved in JSON format. They can be edited via the engine editor or by opening the file and editing it manually. I ")),
        _createVNode(_component_Accent, null, {
          default: _withCtx(() => _cache[33] || (_cache[33] = [
            _createTextVNode("made a separate tool (a simple console application in C++)")
          ])),
          _: 1
        }),
        _cache[35] || (_cache[35] = _createTextVNode(" that read this JSON file and moved all those files to the PS4 and converted the images to the format the PS4 wanted. The JSON file was super nice for easily reading which files were needed for PS4, but for Windows it would probably have been better to use meta files like bigger engines such as Unity or Unreal do."))
      ]),
      _cache[37] || (_cache[37] = _createElementVNode("p", { class: "game-description" }, "In case loading a resource fails, the resource manager falls back on default resource files that are compiled with the engine. This way, at least something gets loaded, like in Source Engine you get the famous purple-black texture.", -1)),
      _cache[38] || (_cache[38] = _createElementVNode("p", { class: "game-description" }, "The resource system also has a few tools such as viewing the loaded resources and interacting with them. You can play, pause and stop sounds and music, view sprite sheets and test if rooms get parsed properly.", -1))
    ]),
    _cache[39] || (_cache[39] = _createStaticVNode("<section class=\"content-section\" data-v-603d8ced><h1 class=\"title\" data-v-603d8ced>The game</h1><video class=\"media-video right\" controls aria-hidden=\"true\" data-v-603d8ced><source src=\"/gudenuffengine/src/mp4/gudenuffengine_gameplay.webm\" type=\"video/webm\" data-v-603d8ced><source src=\"/gudenuffengine/src/mp4/gudenuffengine_gameplay_c.mp4\" type=\"video/mp4\" data-v-603d8ced> Your browser does not support the video tag. </video><p class=\"game-description\" data-v-603d8ced>Drums of Harmony is a 2D rhythm-based roguelike, where you as a spirit bard are trying to cleanse evil Yokai in order to save your village from mysterious disappearances, while using your spirit Daiko drums to create a harmonious melody.</p><p class=\"game-description\" data-v-603d8ced>Play as a spirit bard that can move, shoot and collect to deal with enemies and clear rooms, levels and zones, all on the beat of the soundtrack.</p></section>", 1))
  ]))
}